import { Container } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { HuchaStandardButtons } from '../../ui/hucha-venta-standard-buttons';

export const HuchaStandardCardC3 = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	return (
		<Container stretchContent data-testid="card-c3-container">
			<HuchaStandardButtons dataTestId="card-c3-buttons" huchaValues={huchaValues} />
		</Container>
	);
};
